import cx from 'classnames';
import CodeChallenge from 'modules/codechallenges/containers/CodeChallenge';
import Note from 'modules/notes/containers/NoteContainer';
import Project from 'modules/projects/containers/ProjectContainer';
import Quiz from 'modules/quizzes/containers/Quiz';
import VideoTutorial from 'modules/videotutorials/containers/VideoTutorial';
import PropTypes from 'prop-types';
import React from 'react';
import {Helmet} from 'react-helmet';
import StepsSidebar from './StepsSidebar';
import {
  hidden,
  onMobileScreen,
  sidebarClose,
  sidebarOpen,
  stepContainer,
  sticky,
} from './styles.scss';

const {PARTNER} = process.env;

const getStepComponent = (type) => {
  switch (type) {
    case 'codechallenge':
      return CodeChallenge;
    case 'note':
      return Note;
    case 'project':
      return Project;
    case 'quiz':
      return Quiz;
    case 'videotutorial':
      return VideoTutorial;
    default:
      // This is a hack that should be removed when https://github.com/fugoki/fugoki-school/issues/734 is fixed
      // This should throw an error
      return CodeChallenge;
  }
};

const Step = ({
  authenticated,
  closeSidebar,
  course,
  courseSlug,
  intl: {formatMessage},
  relatedSteps,
  sidebar,
  step,
  stageSlug,
  stepSlug,
  track,
  type,
}) => {
  const StepComponent = getStepComponent(type);
  const trackTopicName = track && track.topic && track.topic.name;
  return (
    <div className={cx(stepContainer, {[hidden]: sidebar})}>
      <Helmet
        title={`${step.name} | ${formatMessage({
          id: PARTNER === 'BARMEJ' ? 'helmet_barmej' : 'partner_helmet',
        })}`}
      />
      {authenticated && (
        <div className={`${sticky} flex overflow-x-hidden`}>
          <StepsSidebar
            closeSidebar={closeSidebar}
            courseName={course.name}
            courseSlug={courseSlug}
            courseStages={course.stages || []}
            isDegree={!!track.degree}
            sidebar={sidebar}
            stageSlug={stageSlug}
            stepName={step.name}
            stepSlug={stepSlug}
            track={track}
          />
          <div
            className={cx('flex flex-column flex2 min-w-0', onMobileScreen, {
              [sidebarOpen]: sidebar,
              [sidebarClose]: !sidebar,
            })}
          >
            <StepComponent
              key={step.id}
              authenticated={authenticated}
              step={step}
              codeChallengeHelperYoutubeId={track.codeChallengeHelperYoutubeId}
              courseId={course.id}
              courseSlug={courseSlug}
              isDegree={!!track.degree}
              nextStepProps={{
                courseId: course.id,
                stepId: step.id,
                trackId: track.id,
              }}
              relatedSteps={relatedSteps}
              stageSlug={stageSlug}
              stepSlug={stepSlug}
              trackSlug={track.slug}
              trackId={track.id}
              trackTopicName={trackTopicName}
            />
          </div>
        </div>
      )}
    </div>
  );
};

Step.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  course: PropTypes.object.isRequired,
  courseSlug: PropTypes.string.isRequired,
  intl: PropTypes.object,
  relatedSteps: PropTypes.array.isRequired,
  sidebar: PropTypes.bool,
  stageSlug: PropTypes.string.isRequired,
  stepSlug: PropTypes.string.isRequired,
  step: PropTypes.object.isRequired,
  track: PropTypes.object,
  type: PropTypes.string.isRequired,
};

export default Step;
